<template>
  <v-dialog
    v-model="show"
    max-width="500px"
    scrollable
    persistent
  >
    <v-card :loading="formProcessing">
      <v-card-title>
        <span class="headline">{{ formTitle }}</span>
      </v-card-title>

      <v-card-text>
        <v-container>
          <v-form>
            <v-row>
              <v-col
                cols="12"
                md="12"
              >
                <v-text-field
                  v-model="heartbeatName"
                  required
                  label="Heartbeat Name"
                  :error-messages="heartbeatNameErrors"
                  @input="v$.heartbeatName.$touch()"
                  @blur="v$.heartbeatName.$touch()"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col
                cols="12"
                md="12"
              >
                <v-text-field
                  v-model="interval"
                  required
                  label="Interval"
                  :error-messages="intervalErrors"
                  @input="v$.interval.$touch()"
                  @blur="v$.interval.$touch()"
                />
              </v-col>
            </v-row>
          </v-form>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer />

        <v-btn
          color="blue darken-1"
          text
          :disabled="formProcessing"
          @click="close()"
        >
          Cancel
        </v-btn>

        <v-btn
          color="blue darken-1"
          text
          :disabled="formProcessing"
          @click="save()"
        >
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex';
import { useVuelidate } from '@vuelidate/core';
import { required } from '@vuelidate/validators';

export default {
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
    editedItem: {
      type: Object,
      default() {
        return {
          id: null,
          heartbeat_name: '',
          interval: '',
        };
      },
    },
  },
  setup() { return { v$: useVuelidate() }; },
  validations: {
    heartbeatName: {
      required,
    },
    interval: {
      required,
    },
  },
  data() {
    return {
      valid: false,
      id: null,
      heartbeatName: '',
      interval: '',
      formProcessing: false,
    };
  },
  computed: {
    show: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit('update:modelValue', value);
      },
    },
    formTitle() {
      const newOrUpdate = this.isNewItem ? 'New' : 'Update';
      return `${newOrUpdate} Monitor`;
    },
    isNewItem() {
      return !this.editedItem.id;
    },
    heartbeatNameErrors() {
      const errors = [];

      if (!this.v$.heartbeatName.$dirty) {
        return errors;
      }

      if (this.v$.heartbeatName.required.$invalid) {
        errors.push('Monitor heartbeat name is required.');
      }

      return errors;
    },
    intervalErrors() {
      const errors = [];

      if (!this.v$.interval.$dirty) {
        return errors;
      }

      if (this.v$.interval.required.$invalid) {
        errors.push('Monitor interval is required.');
      }

      return errors;
    },
  },
  watch: {
    editedItem() {
      this.id = this.editedItem.id;
      this.heartbeatName = this.editedItem.heartbeat_name;
      this.interval = this.editedItem.interval;
      this.active = this.editedItem.active;
    },
  },
  methods: {
    ...mapActions('notification', ['setNotification']),

    save() {
      this.v$.$touch();

      if (!this.v$.$invalid) {
        this.formProcessing = true;
        let request = '';
        const data = {
          heartbeat_name: this.heartbeatName,
          interval: this.interval,
          active: this.active ?? 0,
        };

        if (this.isNewItem) {
          request = this.$axios.post('/api/v1/monitor', data);
        } else {
          request = this.$axios.put(`/api/v1/monitor/${this.editedItem.id}`, data);
        }

        request
          .then((res) => {
            this.$emit('item-saved');

            this.setNotification({
              message: `${res.data.heartbeat_name} has been saved.`,
              color: 'green',
            });
          })
          .catch(() => {
            this.setNotification({
              message: 'There was an error processing your request.',
              color: 'red',
            });
          })
          .then(() => {
            this.formProcessing = false;

            this.close();
          });
      }
    },
    close() {
      this.v$.$reset();

      this.$emit('close-modal');

      this.heartbeatName = '';
    },
  },
};
</script>

<style></style>
